<div [ngSwitch]="slideType">
  <st-multiplechoice-element
    *ngSwitchCase="'MultipleChoiceQuestion'"
    (save)="saveSlide($event)"
  ></st-multiplechoice-element>
  <st-slider-element *ngSwitchCase="'SliderQuestion'" (save)="saveSlide($event)"></st-slider-element>
  <st-wordcloud-element (save)="saveSlide($event)" *ngSwitchCase="'WordcloudQuestion'"></st-wordcloud-element>
</div>
